<template>
    <div>
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
        <v-card class="box">
         <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Faculty Post Linking</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col sm="6" md="6">
                    <v-autocomplete
                        :items="inst_list"
                        item-value="id"
                        v-model="inst"
                        item-text="name"
                        label="Search Instructor"
                        dense
                        rounded
                        outlined
                        placeholder="Search by Emp code or Name"
                        color="#0f2027"
                        @click="putnull()"
                        @change="getPost()"
                    ></v-autocomplete>
                </v-col>
            </v-row>
             <v-row justify="center" v-if="inst">
            <span v-for="post in post_list" :key="post.id">
                <v-checkbox multiple class="mr-5" color="#0f2027" dense v-model="add_inst_post" :label="post.name" :value="post.id" :loading="load"></v-checkbox>
            </span>
            <v-btn v-if="post_list!='' && add_inst_post!=''" class="button mt-4" small @click="addPost()">Add Post</v-btn> 
            </v-row>
        </v-card>
        <v-card class="box" v-if="inst && inst_post_list!=''">
         <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Faculty All Post</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br>
                <v-data-table dense :headers="headers" :items="inst_post_list" sort-by class="elevation-1 mytable" >
                    <template v-slot:item.action="{ item }">
                        <div>
                            <v-btn v-if="item.name != 'Self'" fab outlined icon x-small  class="delete-avatar" @click="deleteItem(item)">
                                <v-icon small color="error" class="mr-2 delete-v-icon"  title="delete">delete</v-icon>
                            </v-btn>
                           <span v-else class="slide"> Un-Deletable </span>
                        </div>
                    </template>
                </v-data-table>
        </v-card>
         <v-dialog v-model="dialog_delete_option1" persistent max-width="500px">
                    <v-card>
                        <v-container>
                        <v-card class="box">
                            <input type="hidden" v-model="deleteItem_opt1.delete_id1" />
                            <strong>Are you sure you want Delete post???</strong>
                            <v-row justify="center">
                            <v-btn class="button" text @click="dialog_delete_option1 = false">No</v-btn>
                            <v-btn class="button" text @click="deletepost()">Yes</v-btn>
                            </v-row>
                        </v-card>
                        </v-container>
                    </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        /*
      Defines the data used by the component
    */
        data() {
            return {
                load: false,
                loading3: false,
                search: "",
                inst_list:[],
                inst:null,
                search:'',
                snackbar_msg: "",
                color: "",
                snackbar: false,
                inst_post_list:[],
                post_list:[],
                add_inst_post:[],
                 headers: [
                    { text: "Sr. No.", value: "srno" },
                    { text: "Instructor", value: "inst_name" },
                    { text: "Faculty Post", value: "name" },
                    { text: "Action", value: "action" },
                ],
                dialog_delete_option1:false,
                deleteItem_opt1: {
                    delete_id1: ""
                },
            };

        },
         mounted(){
            this.onload()
         },
          methods: {
              deleteItem(item){
                   this.dialog_delete_option1 = true;
                    this.deleteItem_opt1.delete_id1 = item.id;
              },
              deletepost(){
                const data = {
                    id : this.deleteItem_opt1.delete_id1,
                    inst_id : this.inst
                }
                 axios
                    .post("/SelfAppraisal/deletepost",data)
                    .then((res) => {
                        if(res.data.flag == "YES"){
                            this.showSnackbar("#4caf50", "Faculty post deleted..."); 
                            this.dialog_delete_option1 = false;
                            this.getPost()
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.dialog_delete_option1 = false;
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                         this.dialog_delete_option1 = false;
                        //close loader
                    });
              },
            addPost(){
                this.load = true
                const data = {
                    add_inst_post: this.add_inst_post,
                    inst_id: this.inst
                }
                 axios
                    .post("/SelfAppraisal/addPost",data)
                    .then((res) => {
                        if(res.data.flag == "YES"){
                             this.load = false;
                              this.showSnackbar("#4caf50", "Faculty post added..."); 
                            this.getPost()
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                         this.load = false;
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                         this.load = false;
                        //close loader
                    });
            },
            putnull(){
                 this.post_list = [];
                 this.inst_post_list = [];
            },
            showSnackbar(clr, msg)
            {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getPost(){
                const data ={
                     inst_id: this.inst
                }
                axios
                    .post("/SelfAppraisal/getPost",data)
                    .then((res) => {
                        if(res.data.flag == "NO"){
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return
                        }
                        if(res.data.flag == "YES"){
                            this.post_list = res.data.post_list;
                            this.inst_post_list = res.data.inst_post_list;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            onload(){
                 axios
                    .post("/SelfAppraisal/getInstructor")
                    .then((res) => {
                        this.inst_list = res.data.inst_list;
                    })
                    .catch((error) => {
                        window.console.log(error);
                        
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        //close loader
                    });
            }
          }
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
    background: #0f2027; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid darkred;
    }
    .delete-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }
</style>
